var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNamibia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.85 70.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m62.52 5.16 1.12-.22 1.07-.21L66 4.51l1-.17h.25l2.4.2 1 .13.37.14.47.36.87.87h-.22l-1.61.18-.61.24-1.37 1-.29-.14-.33-.21-.29-.11-.6.25-.6.29-.66.46-.55.41-.18.23-.85.84-.28.14-.25.06h-.1l-.11-.36-.52-.86-.85-1.11-.24-.11h-.8l-1.81.32-1.54.26-2.35.46-2.52.36-1.55.23-1.35.07v20.34h-5.2v37.15h-.53l-1.08.32-.69.42-.3.52-.39.31-.5.11-.22.27.06.41-.19.32-.44.23-.71-.07-1-.35-1.25-.08L36 69l-1.09-.08-.67-.36-.7-.21h-.74l-.44-.15-.88-.27-.17-.45-.1-.35-.21-.4v-.3l.2-.22v-.36l-.14-.5-.24-.24h-.35l-.21-.19-.09-.39-.2-.3-.49-.3-.64.22-.31.35-.17.54-.17.27-.08.45v.32l-.16.34-.17.13-.18-.06-.33.14-.73.5-.21.27-.58-.48-1.72-1.81-.61-.47-.9-1.1-2-3.4-.29-.66-.37-1.63-.44-1.22v-.69l.2-.4-.23-.54-.23-.48-.67-.63-.19-2.08-.45-1.35.1-1.11-.22-1v-.64l.1-1.23-.37-1.41-.73-1.37-.66-2-.1-.86.03-2.28-.13-1v-1.1l-.26-1.15-.1-.63.18-.49.11.16.19.07.13-.65v-.58l-.33-1.43-.74-1.46-1.77-2.3-.44-.9-.26-.75-2-3.11-.9-2.24-.61-1.88-.66-.87-3.06-6.04-.67-1-1.22-1.12-.29-.38-.47-1.1-.91-1.47-.23-1.37-.06-1.55L1.61 3l.84-.12.55-.29h.53l.51.25h1.77l.56-.28.68-.29.4-.27.55-.24.72-.26h.41l.5.1.67.1.38.17.45.55.7.51.51.3.58.39.18.15.26.09h.16l1.09-.06H36.6l.17.11.14.1.53.69.68.73.56.34.68.21.63.07h.6l1 .1 1.37.23 1.43.07 1.48-.1 1 .13.61.36.61.24.63.13.85-.08 1.08-.27h.91l.42.2h.25l1.58-.29 1.27-.23 1.92-.3 1.57-.31 2.33-.45z",
    "data-name": "Layer 93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamibia);
export default __webpack_public_path__ + "static/media/namibia.c29cf721eb537073bc0e16903a6fe6df.svg";
export { ForwardRef as ReactComponent };